import axios from "axios";
import {Api_url} from "./NETWORKCONSTS";

export function ticketSubscribe_getByPlace(data) {
    return axios.get(Api_url.TicketSubscribe.getByPlace,{ params : data });
}

export function ticketSubscribe_query(data) {
    return axios.post(Api_url.TicketSubscribe.query, data);
}
